import React from "react";
import { Flex, Box } from "theme-ui";
import ContentText from "@solid-ui-components/ContentText/ContentText";
import styles from "./styles";
import optimizedOperationsImage from "../../../../../targpatrol-en/content/assets/flexiblocks/restaurant/optimized-operations.svg";
import incidentManagementImage from "../../../../../targpatrol-en/content/assets/flexiblocks/restaurant/incident-management.svg";
import analyticsReportingImage from "../../../../../targpatrol-en/content/assets/flexiblocks/restaurant/analytics-and-reporting.svg";
import FlexContent from "@solid-ui-components/FlexContent/FlexContent";

const images = [
  optimizedOperationsImage,
  incidentManagementImage,
  analyticsReportingImage
];

const ManagementFeatures = ({ content }) => {
  return (
    <FlexContent >
      <Box sx={styles.headerContainer}>
        <ContentText content={content.text?.[0]} sx={{ maxWidth: '700px', mt: '80px' }} />
        <ContentText content={content.text?.[1]} sx={{ maxWidth: '994px' }} />
      </Box>
      <Flex sx={styles.cardsContainer}>
        {content.collection?.map((card, index) => (
          <Box
            key={index}
            sx={{
              ...styles.card,
              backgroundImage: `url(${images[index]})`,
            }}
          >
            <Box sx={styles.cardContent}>
              <ContentText content={card.text} sx={{ mb: '8px' }} />
            </Box>
          </Box>
        ))}
      </Flex>
    </FlexContent>
  );
};

export default ManagementFeatures;
